<template>
  <div class="py-8 px-9">
    <StudentRequirementsDataTable />
  </div>
</template>

<script>
import StudentRequirementsDataTable from "@/components/Utils/StudentRequirementsDataTable.vue";
export default {
  name: "StudentRequirementPage",
  components: {
    StudentRequirementsDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
